import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import { history }  from '../routers/AppRouter'
import   jwt from 'jsonwebtoken';
// import { FooterSection } from './FooterSection'; 
import   format from 'date-fns/format';
import   isEqual from 'date-fns/isEqual';
import   PicGetRequest  from '../apis/PicGetRequest';
import   Footer from "../components/common/Footer";
import   PicPutRequest  from '../apis/PicPutRequest';
import   TextButtonGroup  from './buttons/TextButtonGroup';
import   PicInvitationContribPanel  from './PicInvitationContribPanel';
import   PicInvitationHelpPanel  from './PicInvitationHelpPanel';
import { ErrorMessage } from './ErrorMessage';
import { SimpleButton } from './buttons/SimpleButton';
import { HorizRule } from './decorators/HorizRule';
import   AppConfig from '../config/AppConfig';
import { SimpleModal } from './modals/SimpleModal';
import  getAppConfigParm  from '../config/AppConfig';
import  VisibilityWrapper from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';
import  LinkIcon from '@material-ui/icons/Link';
import { prtStart, prtInput, prtMsg, prtVar, prtErr }   from  '../utils/prt';
// import { GoogleAdInit } from './advertisement/GoogleAdInit';

const FNAME = "PicInvitationMock.js";
const TRACE = true;


// *************************************************************************************************
// Component process
// When component mounts the following occurs:
//   - Make api call to get eventObj and saves event info in local state
// In the render():
//   - Component renders event details
//   - It also renders a prompt when user responds with yes and a prompt for no
//   - Provides user option to Pitch In.
// *************************************************************************************************
// FUTURE STATE: whenever you need to render a page both for internal user and external user, be 
//  sure to adhere to following guidelines:
//  - Ensure page has only presentation logic
//  - You typically will not set up a redux store for a single page (especially if used as exteral page
//    addition to internal page). Therefore, use real-time api calls instead of redux store. Store 
//    data locally in the class/Component. This will avoid any logic needed to determine if you are
//    getting data from redux store, geting it directly from the api, or local variables.
//  - Separate out API call(s) to external file (eg. api/fetchEventInfo())
//  - If API requires promise chaining, return one data object with the various results as properties.
//  - If you want to be able to use the API for both external and internal page, provide an 
//    option, parm, or setting to either call API's public route or private route. This keeps this 
//    logic outside the presentation logic.
//  - Routes should be preconfigured. Any parms needed to complete the url string, for example the
//    event id  (eg. /event/:id), should passed as a paramter to api.
// ***************************************************************************

// ***************************************************************************
/* Styles                                                                   */
// ***************************************************************************

const blue = "#2980B7";

/* Style was carried over from Shareable Link to be able to just show the link 
   without having to bring over the fully functional component */
const linkStyle = {          /* leave this style here. Did not work when coded in stylesheet */
    color: blue,
    paddingLeft: '.5rem',
    textDecoration: 'none',
}

// ***************************************************************************
// Helper functions 
// ***************************************************************************

const TopBorder = () => (
    <div className="pic-event-tb"/> 
);

// const renderDateAndTime = (startDate, startTime, endDate, endTime) => { 

//     /* set flag as to whether startdate and enddate are the same */
//     let isStartAndEndDateEqual = isEqual(startDate, endDate);

//     /* construct Jsx for when start and end dates are same */
//     let sameDayJsx = (
//         <div>
//             <span>Date:&nbsp;</span> <span className="invites-event-field">{`${format(startDate, 'MMMM, dd, YYYY')}`} </span>
//             &nbsp;&nbsp;&nbsp;
//             <span className="invites-event-field">{`${format(startTime, 'hh:mm a')} - ${format(endTime,'hh:mm a')}`}</span>
//         </div>
//     )

//     /* construct Jsx for when start and end dates are different */
//     let differentDaysJsx = (
//         <div>
//         <span>Date:&nbsp;</span><span className="invites-event-field">{`${format(startDate, 'MMM, dd, YYYY')} ${format(startTime,'hh:mm a')} - ${format(endDate, 'MMM, dd, YYYY')} ${format(endTime, 'hh:mm a')}`}</span>
//         </div>
//     )

//     /* render jsx based on condition */
//     if (isStartAndEndDateEqual) {
//         return sameDayJsx;
//     } else {
//         return differentDaysJsx;
//     }
// }


const renderDateAndTime = (startDate, startTime, endDate, endTime) => { 

    /* set flag as to whether startdate and enddate are the same */
    let isStartAndEndDateEqual = isEqual(startDate, endDate);

    /* construct Jsx for when start and end dates are same */
    let sameDayJsx = (
        <div>
            <span>Date:&nbsp;</span> <span className="invites-event-field">{`${format(startDate, 'MMMM, dd, YYYY')}`} </span>
            &nbsp;&nbsp;&nbsp;
            <span className="invites-event-date">{`${format(startTime, 'hh:mm a')} - ${format(endTime,'hh:mm a')}`}</span>
        </div>
    )

    /* construct Jsx for when start and end dates are different */
    let differentDaysJsx = (
        <div className="pic-event-detail-sectionx" style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div  className="pic-event-label">Date:</div> 
                <div className="invites-event-field">{`${format(startDate, 'MMM, dd, YYYY')} ${format(startTime,'hh:mm a')}`}</div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div className="pic-event-label">To :&nbsp;</div> 
                <div className="invites-event-field">{`${format(endDate, 'MMM, dd, YYYY')} ${format(endTime, 'hh:mm a')}`}</div>
            </div>
        </div>
    )

    /* render jsx based on condition */
    if (isStartAndEndDateEqual) {
        return sameDayJsx;
    } else {
        return differentDaysJsx;
    }
}

/* Renders all the information about the event */
// const eventDetailSection = (title, location, startDate, startTime, endDate, endTime,  organizer, message, clearPage) =>  {
//     // let errormsg = this.state.formError || '';

//     return (
//         <div>
//             <div className="pic-event-detail-section">
//                 <div className="pic-event-title">{`Invitation to ${title}`}</div> 
//                 <span>Organizer: &nbsp;</span><span className="invites-event-field">{organizer}</span>
//                 {renderDateAndTime(startDate, startTime, endDate, endTime)}
//                 <span>Location: &nbsp;</span><span className="invites-event-field">{location}</span>
//                 { !clearPage && <div className="pic-event-message">{message}</div> }
//             </div>
//         </div>
//     )
// }

const eventDetailSection = (title, location, startDate, startTime, endDate, endTime,  organizer, message, clearPage) =>  {
    // let errormsg = this.state.formError || '';
    //TRACE && prtStart(compName, 'eventDetailSection');
    //TRACE && prtInput('title', title);
    //TRACE && prtInput('location', location);
    //TRACE && prtInput('message', message);
    //TRACE && prtInput('clearPage', clearPage);

    return (
        <div>
            <div className="pic-event-detail-section">
                <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb="2rem" />
                <div className="pic-event-mock-title">{title}</div> 
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <LinkIcon className="slo-icon"/> 
                    <div style={linkStyle} >Get shareable link</div>          
                </div> 
                <HorizRule color="#95A5A6" pctWidth="95%" thickness=".1rem" mb="2rem" />
                <div style={{display: 'flex'}}>
                    <div className="pic-event-label">Organizer:</div>
                    <div className="invites-event-field">{organizer} </div>
                </div>

                <div>{renderDateAndTime(startDate, startTime, endDate, endTime)}</div>

                <div className="rc-flex-container-r2c">
                    <div className="pic-event-label">Location:&nbsp;</div>
                    <div className="invites-event-field">{location}</div>
                </div>   
                
            </div>
            {!clearPage && 
                <div className="pic-event-detail-section">
                    <div className="pic-event-label">Message:&nbsp;</div>
                    <div className="pic-event-message">{message}</div>
                </div>
            }
        </div>
    )
}



// This page uses the PicEventsTable component. This a flex table component that 
// takes as props an array of rows (each row has array of column/cells) that allows for a 
// fixed number of columns (eg 3 or 4). Note that the contents of each cell or column
// in the flex table can be text or jsx. The mapping of the data to the JSX structures
// is done in the componentDidMount lifecycle method.
class PicInvitationMock extends React.Component { 

    constructor(props) {
        // //TRACE &&prtStart(compName, 'constructor');
        super(props);

        this.state = {
            eventObj: {},
            contributions: [],
            helpingHandsList: [],
            participantEmail: '',
            participantName:  '',
            showModal: false,
            userMadeContribution: false,   /* pops up modal if user submits response without contribution */
            // headerLabels: ["Item Description", "Qty Needed", "Contribution", ""],
            panel1IconOpen:    false,   /* false means icon close position, true is open position*/
            panel2IconOpen:    false,   /* false means icon close position, true is open position*/
            displayLists:  false,
            rsvpFlag:      "",   /* used to know when to put check mark next to text button */
            clearPage:     false,   /* set to true when user clicks pitch in button. Clears screen to show lists */
            attend:  "n",         /* participant attendance is set to No as default */
            responseSubmitted: false,  /* When this is true Submit response button is hidden and message is displayed */
            // externalToken: '',       /* token from external user */?
            buttonClickedValue: 0,   /* used by TextButtonGroup to indicate which text button was clicked */
            textButtonCheckMarks: {checkMark1: false,  checkMark2: false},  /* manage checkMark toggle on TextButtonGroup */ 
            formError: ''
        }
    }

    //*************************************************************************
    // Lifecycle methods
    //*************************************************************************

    // Initialize event list
    componentDidMount = () => {
        //TRACE && prtStart(FNAME, "componentDidMount");

        let self = this;

        let eventObj = {};
        let event_id = '';
        let contributions = [];
        let token = '';
        let invitationKey = '';
        let participantEmail = '';
        // let isToken = false;
        // let event_id = '';
        // let participantName = '';
        let contrib_uri = '';
        let decodedToken = '';
        let get_event_uri = '';
        let get_helplist_uri = '';
        
        /* Determine if this is an external request */
        // let isExternalRequest = this.props.auth.isAuthenticated ? false : true;   // v116 removed
        let isExternalRequest = false;   // v116 added

        // V116 removed if else block below
        /* Set up appropriate routes and token based on whether user is external or is logged in and authenticated*/
        // if (isExternalRequest) {
        //     TRACE && prtMsg("Inside 'if (isExternalRequest)' block");

        //      /* get token */
        //     token = this.props.match.params.token;
        //     this.setState({externalToken: token});  /* save external token so it may be used by other api calls outside componentDidMount */
        //     // console.log("This token ", token)

        //     /* verify token is valid  */
        //     invitationKey = AppConfig("invitationkey")
        //     try {
        //         decodedToken = jwt.verify(token, invitationKey);
        //         // console.log("This is decoded token ", decodedToken);
        //     } catch(e) {
        //         this.setState({formError: "InvalidUrl: string may have been corrupted. Try clicking on invitation email again"});
        //     }


        //     /* get participantEmail and event id  from decoded token */
        //     participantEmail = decodedToken.email;
        //     event_id  = decodedToken.event_id;     
        //     // console.log(`This is eventid ${event_id} this is participant email ${participantEmail}`)
        //     /* define public uris  for the api calls*/
        //     contrib_uri   = `/invitation/event/${event_id}/contributions/${participantEmail}`; /* public route */
        //     get_event_uri = `/event/${event_id}/participant/${participantEmail}/name`; /* this one reads participants collection to get name */
        //     get_helplist_uri = `/invitation/event/${event_id}/todos/${participantEmail}`;
        // } else {
        //     TRACE && prtMsg("Inside 'if (isExternalRequest)' else block");
        //     /* Check if token is GT 24 chars (external), user is trying to view invitation from external email while logged in */
        //     if (token.length > 24) {
        //           /* logoff the user so they can process request */
        //           this.props.startLogout();
        //           return;
        //     }
        //     /* get token */
        //     token  = this.props.auth.token;
        //     /* get participantEmail and event id  from decoded token */
        //     participantEmail = this.props.auth.user.email;
        //     event_id = this.props.event.active._id;
        //     contrib_uri   = `/event/${event_id}/contributions/`;       /* private route */
        //     get_event_uri = `/event/${event_id}`; /* No need to use composite service as we can get name of logged in user from redux store */
        //     get_helplist_uri = `/event/${event_id}/todos`
        // }; 

        
        //TRACE && prtVar("this.props.auth.user", this.props.auth.user)
        token  = this.props.auth.token;
        participantEmail = this.props.auth.user.email;
        event_id = this.props.event.active._id;
        contrib_uri   = `/event/${event_id}/contributions/`;       /* private route */
        get_event_uri = `/event/${event_id}`; /* No need to use composite service as we can get name of logged in user from redux store */
        get_helplist_uri = `/event/${event_id}/todos`


        //TRACE && prtMsg(this.state.formError ? "Found formError; leaving componentDidMount" : "No Form Error");

        if (this.state.formError) return;        /* get out here if error encountered */
               
        /* Fire API Request to get Event info along with participant name; Note this public route is used for both internal and external requests  
           For external requests, the token is not set */
       let step = "notStarted";
       let getRequest = new PicGetRequest("GetEventById")
            .setUserId(participantEmail)
            .setUri(get_event_uri)
            .setLogTrace(false)
            .setAuthToken(token);  /* set token for internal request */   // V116 added in place of line below
            // if (!isExternalRequest) { getRequest.setAuthToken(token); } /* set token for internal request */   // v116 Replaced with line above
            step = "getEvent";    /* This step gets event info along with participant name from  participants collection */         
            getRequest.exec().then((response) => {
                //TRACE && prtMsg("GetEventById api call completed, below is event object")
                eventObj = response.data || {};
                //TRACE && prtVar("eventObj", eventObj)
                eventObj.participantEmail = participantEmail;  /* add participantEmail property to object */
                eventObj._id = event_id;
                // if (isExternalRequest) {  /* name will be in eventObj */
                //     self.setState({eventObj, participantEmail, participantName: eventObj.participantName});   // v116 remove conditional block
                // } else {                  /* name will come from redux store as user is logged in */
                    let participantName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname;
                    self.setState({eventObj, participantEmail, participantName});
                // }
                /* set up request to get contributions */
                step = "getContributions";
                let getContributionsRequest = new PicGetRequest("GetContributions")
                .setUserId(participantEmail)
                .setUri(`${contrib_uri}`)
                .setLogTrace(false)
                .setAuthToken(token);                              /* set token for internal request */  // v116 add see note above
                // if (!isExternalRequest) { getContributionsRequest.setAuthToken(token); } /* set token for internal request */  // v116 replace with below
                return getContributionsRequest.exec()
        }).then ((response) => {
                //TRACE && prtMsg("GetContributions api call completed, below is contribution list")
                let contribList = response.data.items || [] ;
                //TRACE && prtVar("contribuList", contribList);
                contributions = this.mapContribDataToFlexTable(contribList);
                this.setState({contributions, panel1IconOpen: false});
                /* set up request to get contributions */
                step = "getHelpingHandsList";
                let getHelpListRequest = new PicGetRequest("GetHelpingHandsList")
                .setUserId(participantEmail)
                .setUri(`${get_helplist_uri}`)
                .setLogTrace(false)
                .setAuthToken(token);  /* set token for internal request */     //v116 this and next line commented out
                // if (!isExternalRequest) { getHelpListRequest.setAuthToken(token); } /* set token for internal request */
                return getHelpListRequest.exec()
        }).then ((response) => {
            //TRACE && prtMsg("GetHelpingHandsList api call completed, below is hhlist")
            let hhList = response.data.todos || [] ;
            //TRACE && prtVar("hhlist", hhList);
            let helpingHandsList = this.mapHelpDataToFlexTable(hhList);
            // helpingHandsList = this.mapHelpDataToFlexTable(hhList);   // <<< ============== NEXT
            this.setState({helpingHandsList, panel2IconOpen: false});
        }).catch((error) => {
            prtErr(error);
            let errmsg = '';
            switch (step) {
                case "getEvent":
                    if (error.status === 404) {
                        errmsg = `NotFound: did not find participant email '${participantEmail}' for given event`
                    }
                    break;
                case "getHelpingHandsList":
                        errmsg = `Error: found in ${step} for user '${participantEmail}' for event '${event_id}'`
                    break;
                default: 
                    errmsg = `Encountered error ${error} in ${step} request`;
            }
            self.setState({formError: errmsg})
        });
    } /* end of component did mount */

    //*************************************************************************
    // Event Handlers
    //*************************************************************************

    /* this handler is used by ErrorMessage Component. When user clicks the X
     it clears the formError value and effectively closes the message box */
    clearErrorMessage = () => {
        this.setState({formError: ''})
    }

    /* This is fired when user clicks caret icon on the expansion panel1 */
    handleOnClickForPanel1 = () => {
        let yes  = true;
        let no  = false;

        /* user clicked icon, therefore flip state */
        let panel1IconOpen = !this.state.panel1IconOpen

        /* makes sure both tables are not expanded at the same time. If panel2 is open when panel1 icon clicked,
           then close it  */
        if (panel1IconOpen === true)  {  
            this.setState({panel1IconOpen: true, panel2IconOpen: false })   
        } else if (panel1IconOpen === false) {
            this.setState({panel1IconOpen: false})    
        }
    } 

    /* This is fired when user clicks caret icon on the expansion panel2 bar */
    handleOnClickForPanel2 = () => {
        let yes  = true;
        let no  = false;

        /* user clicked icon, therefore flip state */
        let panel2IconOpen = !this.state.panel2IconOpen

        /* makes sure both tables are not expanded at the same time. If panel1 is open when panel2 icon clicked,
           then close it  */
        if (panel2IconOpen === true)  {  /* reset flag to hide message */
            this.setState({ panel2IconOpen: true, panel1IconOpen: false})   
        } else if (panel2IconOpen === false) {
            this.setState({ panel2IconOpen: false})    
        }
    } 

    /* This is fired when user clicks on one of the buttons in the TextButtonGroup. For the mock service we merely  
       show  the checkmark if someone RSVP's 
     */
    handleTextButtonGroup = (buttonClickedValue) => {
                
        let { textButtonCheckMarks } = this.state;

        /* Since user just clicked a text button, lets toggle the checkMark for the button clicked so code below can work with the new state */
        let checkMark1 = buttonClickedValue === 1 ?   !textButtonCheckMarks.checkMark1 : textButtonCheckMarks.checkMark1 ;
        let checkMark2 = buttonClickedValue === 2 ?   !textButtonCheckMarks.checkMark2 : textButtonCheckMarks.checkMark2 ;

        if (buttonClickedValue === 1 && checkMark1) {
            this.setState((state) => {
                return {
                    rsvpFlag: "yes", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else 
        if (buttonClickedValue === 1 && !checkMark1) {
            this.setState((state) => {
                return {
                    rsvpFlag: "", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: checkMark1,  checkMark2: false }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else 
        if (buttonClickedValue === 2 &&  checkMark2) {
            this.setState((state) => {
                return {
                    rsvpFlag: "no", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } else
        if (buttonClickedValue === 2 && !checkMark2) {
            this.setState((state) => {
                return {
                    rsvpFlag: "", 
                    buttonClickedValue, 
                    textButtonCheckMarks: { checkMark1: false,  checkMark2: checkMark2 }, /* toggle checkmark */
                    responseSubmitted: false
                }
            })
        } 

        /* clear form error if one exist */
        if (this.state.formError) {
            this.clearErrorMessage();
        }
    }

    /* Called by child component to raise error */
    handleRaiseError = (text) => {
        this.setState({formError: text});
    }

    /* when user clicks pitch in button; pitchInMode is set to true.  When this flag is set to true
       we hide the message section and everything underneath in order to show the two lists */
    // handleOnClickPitchInButton = () => {
    //     let { rsvpFlag } = this.state;  /* save current state of rsvp  flag */
    //     this.setState({ clearPage: true, displayLists: true, rsvpFlag });
    // }

    handleOnClickBackButton = () => {
        /* Go back by dynamically rendering first page where we do not clearPage or display lists */
        history.push("/eventmanage/invites");
    }

    /* this has been disabled for mock page */
    handleSubmitResponse = () => {
        return;
        // let { eventObj, participantEmail, rsvpFlag } = this.state;

        // /* check that user answerered question, Are you Attending?*/
        // if (this.state.rsvpFlag === "") {
        //     this.handleRaiseError("Response Required: Please let us know if you will be attending")
        // } 

        // /* If user said they were attending but did not make contribution before hitting submit, show modal 
        //    to give them chance to make contribution before submitting response. If user clicks submit, 
        //    set userMadeContribution to true (although not true but purpose of letting user submit response
        //    of Yes without contributions)  */
        // if (!this.state.userMadeContribution && this.state.rsvpFlag === "yes") {
        //     this.setState({showModal: true});
        //     return;
        // }

        // /* Construct request body for update attendance */
        // let updateAttendanceReqBody = {
        //     event_id: eventObj._id,
        //     participantEmail,
        //     attend: rsvpFlag === "yes" ? "y" : "n"
        // }

        // let isExternalRequest = this.props.auth.isAuthenticated ? false : true;

        // let token = isExternalRequest ? this.state.externalToken : this.props.auth.token;
        // let uri   = isExternalRequest ? '/event/invite/participant/attendance' : '/event/participant/attendance';

        // /* Fire off Put request to update attendanace */
        // let step = "nonStarted"
        // let updateParticipantAttendance = new PicPutRequest("updateParticipantAttenance")
        //     .setUserId(participantEmail)
        //     .setUri(uri)
        //     .setRequestBody(updateAttendanceReqBody)
        //     .setAuthToken(token)
        //     .setLogTrace(true);     
        //      step = "updateParticipantAttendance"   
        // updateParticipantAttendance.exec().then((response) => {
        //     console.log("This is response ", response );
        //     this.setState({responseSubmitted: true})
        // // let getContributionsRequest = new PicGetRequest("GetContributions")
        // // .setUserId(participantEmail)
        // // .setUri(`${contrib_uri}`)
        // // .setLogTrace(true);
        // // if (!isExternalRequest) { getContributionsRequest.setAuthToken(token); } /* set token for internal request */
        // // return getContributionsRequest.exec()
        // // }).then ((response) => {
        // //     let contribList = response.data.items || [] ;
        // //     console.log("THIS IS CONTRIB LIST");
        // //     console.log(contribList);
        // //     contributions = this.mapDataToFlexTable(contribList);
        // //     this.setState({contributions});
        // }).catch((error) => {
        //     let errorResponse = updateParticipantAttendance.getError();
        //     console.log("This is axio error message ", errorResponse);
        //     let errmsg = '';
        //     switch (step) {
        //         case "updateParticipantAttendance":
        //                 errmsg = `SomethingWrong: unable to update participant attendance for ${participantEmail}. May want to refresh page or try again`
        //             break;
        //         default: 
        //             errmsg = `SomethingWrong: unable to update participant attendance for ${participantEmail}. May want to refresh page or try again`
        //     }
        //     this.setState({formError: errmsg})
        // });
    }

    /* This is fired when changing contribution value. Cange is reflected in the contribution list in parent*/ 
    handleChangeQuantity = (contributions) => {
        this.setState({contributions});
    }

    /* This mock function suppresses the Count Me In Button on the Contribution List*/
    handleContribCountMeInButton = ()  => {
        console.log("handleContribCountMeInButton mock function")
    }

    /* This mock function suppresses the Remove My Name link on the drop down for contribution list  */
    handleRemoveContributor = ()  => {
        console.log("handleRemoveContributor mock function")
    }

    /* This mock function suppresses the Count Me In Button on the Helping hands list*/
    handleHelpingHandsCountMeInButton = ()  => {
        console.log("handleHelpingHandsCountMeInButton mock function")
    }

    /* This mock function suppresses the Remove My Name link on the drop down for hhlist  */
    handleRemoveHelpingHandsContributor = ()  => {
        console.log("handleRemoveContributor mock function")
    }



    /* Fired when parent component needs to update helping hands list (eg Count Me In Button or remove me form list is clicked)*/
    handleUpdateHelpingHandsList = (helpingHandsList) => {
        return;  /* disabled for mock page */

        // let { eventObj, participantEmail } = this.state;

        // /* token used is based on whether user is internal or external */
        // let token = this.props.auth.isAuthenticated ? this.props.auth.token : this.state.externalToken;

        // /* Transform helpingHandsList to proper Document format. This is used for request object in API call */
        // let todos =  this.mapHelpingHandsListToDocument(helpingHandsList);
        
        // /* construct request object using the transformed todos document. Note that at end of 
        //    api call below, setState is called with original helpingHandsList(flexTable) format to update the store*/
        // let updatedHelpListReqObj = {
        //     event_id: eventObj._id,
        //     todos
        // }

        // /* set uri based on whether this is external user or application user */
        // let uri = this.props.auth.isAuthenticated ? '/event/todos' : '/event/invite/todos';

        // /* Update database with the updated ParticantList.It uses the transformed format. The store 
        //    is updated with flextable format was passed in as parameter  */
        // let updateHelpingHandsList = new PicPutRequest("updateHelpingHandsList")
        //         .setUserId(participantEmail)
        //         .setUri(uri)
        //         .setRequestBody(updatedHelpListReqObj)
        //         .setAuthToken(token)
        //         .setLogTrace(true);     
        //     updateHelpingHandsList.exec().then((response) => {
        //         this.setState({helpingHandsList, userMadeContribution: true })    /* uses flextable format */
        // }).catch((error) => {
        //     let errorResponse = updateHelpingHandsList.getError();
        //     let errmsg = '';
        //     errmsg = `Oops: unable to update help list for participant ${participantEmail}. May want to refresh page or try again`
        //     this.setState({formError: errmsg})
        // });
    }

    mapHelpingHandsListToDocument= (helpingHandsList) => {
        let todos =  helpingHandsList.map((item) => {
            return {
                todo: item[0],
                peopleNeeded: item[1],
                participants:  item[3]
            }
        });
        return todos
    };

    /* Fired when parent component needs to update contribution list for an item (Count Me In Button)*/
    handleUpdateContributionList = (contributions, indexValue, newQuantityNeeded) => {
        return;  /* disabled for mock page */

        // let { eventObj, participantEmail } = this.state

        // /* token used is based on whether user is internal or external */
        // let token = this.props.auth.isAuthenticated ? this.props.auth.token : this.state.externalToken;

        // /* get item */
        // let item = contributions[indexValue][0];

        // /* get contributor list */
        // let contributorList = this.getContributorList(contributions, indexValue);

        // /* construct request object */
        // let updateContributorsReqObj = {
        //     event_id: eventObj._id,
        //     item,
        //     contributorList,
        //     quantity: newQuantityNeeded
        // }

        // /* set uri based on whether this is external user or application user */
        // let uri = this.props.auth.isAuthenticated ? '/event/participant/contributors' : '/event/invite/participant/contributors';

        // /* Update database with the updated ContributorList  */
        // let updateItemContributors = new PicPutRequest("updateItemContributors")
        //     .setUserId(participantEmail)
        //     .setUri(uri)
        //     .setRequestBody(updateContributorsReqObj)
        //     .setAuthToken(token)
        //     .setLogTrace(true);     
        // updateItemContributors.exec().then((response) => {
        //     this.setState({contributions, userMadeContribution: true })
        // }).catch((error) => {
        //     let errorResponse = updateItemContributors.getError();
        //     let errmsg = '';
        //     errmsg = `SomethingWrong: unable to update attendance for participant ${participantEmail}. May want to refresh page or try again`
        //     this.setState({formError: errmsg})
        // });
    }

    // handleOpenModal = () => {

    //     this.setState({showModal: true});
    // }

    handleCloseModal = () => {
        this.setState(
            {showModal: false, userMadeContribution: true},
            () => {this.handleSubmitResponse();}
       );
    }

    handleCancelModal = () => {
        this.setState({showModal: false});
    }


    //*************************************************************************
    // Utilities / or Help functions
    //*************************************************************************

    /* Puts check mark next to text button clicked, but this has some conditional logic needed 
       to override the buttonClicked property */
    setButtonClicked = () => {
        if (this.state.rsvpFlag === "yes") {
            return 1;
        } else if (this.state.rsvpFlag === "no") {
            return 2;
        }
    }

    /* converts the contribution list from an array of objects to an array of array of items to be used by flex table */
    mapContribDataToFlexTable = (contributionList) =>  {
        let convertedArray = contributionList.map( (item) => {
            return   [item.contribution, item.quantity, parseInt(item.quantity,10), "button", item.contributors, "notUpdated"]
        }) 
        return convertedArray;
    }   

    /* converts the helping hands list from an array of objects to an array of array of items to be used by flex table */
    mapHelpDataToFlexTable = (hhList) =>  {
        let hhListArray = hhList.map( (todo) => {
            return   [todo.todo, todo.peopleNeeded, "button", todo.participants, "notUpdated"]
        }) 
        return hhListArray;
    }   

    /* Contributor list  is found as 4th item in table row . Created this help function so that
       if event it moves, I only need to change it one place */
    getContributorList = (contributionList, rowIndex) => {
        return contributionList[rowIndex][4];
    }

    showThankYouMessage = () => {
        let {responseSubmitted, rsvpFlag, formError, userMadeContribution }  = this.state;
        let response = false;
        if (responseSubmitted  &&  rsvpFlag === "yes"  && !formError && userMadeContribution) {
            response = true;
        } else if (responseSubmitted  &&  rsvpFlag === "no"  && !formError && !userMadeContribution ) {
            response = true;
        }
        return response;
    }

    showResponseButton = () => {
        return !this.showThankYouMessage()
    }

    getParentStateValue = (value) => {
        if (value === "participantEmail") { 
            return this.state.participantEmail 
        }
        if (value === "participantName")  { 
            return this.state.participantName  
        }
    }

    //*************************************************************************
    // Component render method
    //*************************************************************************
    render() {
        // TRACE && prtStart(FNAME, "render()")
        // TRACE && prtVar("this.state.eventObj", this.state.eventObj);
        // TRACE && prtVar("this.props.auth", this.props.auth);
        // console.log("This is contributions ", this.state.contributions);
        // console.log("THIS IS THE HELPING HANDS LIST " , this.state.helpingHandsList )
        // let submitResponseButtonColor = this.state.pitchInButtonClickedOnce ? "" : "grey"

        let errormsg = this.state.formError || '';

        let { eventTitle, location, startDate, startTime, endDate, endTime, 
              organizer, eventMessage, userName } = this.state.eventObj;

        let { contributions, helpingHandsList, clearPage, rsvpFlag, panel1IconOpen, panel2IconOpen, responseSubmitted, 
              displayLists, formError, userMadeContribution } = this.state;

        // TRACE && prtVar("this.props.auth.user", this.props.auth.user);
        if (!userName) { userName = this.props.auth.user.firstname + ' ' + this.props.auth.user.lastname };

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");
        let showSkyScraper = false;

        /* set flags used to decide what to render or not */
        let showThankYouMessage = this.showThankYouMessage();
        let showResponseButton  = this.showResponseButton();
        let listItemsHaveBeenCreated  = contributions.length > 0 || helpingHandsList > 0 ? true : false;

        /* if user did not elect to use alternate organizer name, default to organiner name*/
        if (!organizer) {
            organizer = userName;
        }
        // TRACE && prtVar("organizer", organizer)
        
        return (
            <div> 
               <Helmet>
                    <title>My Invitation</title>
                    <meta name="description" content="My Invitation" />
               </Helmet>
               <VisibilityWrapper show={showAd} contentType="advertisement">
               <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                   {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                   {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                   {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
               </div>
               </VisibilityWrapper>  
               <div className="app-container-invitation">    
                  <div className="pic-dashboard-container"> 
                    <div className="pic-invitation-container">
   
                        <TopBorder />
                        <div className="pic-event-mock-section">
                            <div className="pic-event-mock-message"> 
                                    NOTE: Below invite is for preview only. Buttons in preview invitation are not functional.
                            </div>
                            <SimpleButton buttonText="Back" color="lightgrey" onClickHandler={this.handleOnClickBackButton} />
                        </div>
                        <div style={{display: "flex", justifyContent: "center", marginTop: ".3rem"}}>
                           <ErrorMessage text={errormsg} allowClose={true} clearError={this.clearErrorMessage} />
                        </div> 
                        {eventDetailSection(eventTitle, location, startDate, startTime, endDate, endTime, organizer, eventMessage, clearPage)}  
                        <div style={{display: "flex", justifyContent: "center" }}>
                            <HorizRule color="#CC6600" pctWidth="60%" thickness="2px" />
                        </div>

                        <div className="text-button-group-container">
                            <TextButtonGroup 
                                buttonGroupLabel="Will you be Attending?"
                                button1TextAndStyle="Yes:success"
                                button2TextAndStyle="No:fail"
                                buttonClicked={this.state.buttonClickedValue}
                                checkMarks={this.state.textButtonCheckMarks}
                                onClickHandler={this.handleTextButtonGroup}
                            />
                        </div>
                        <div style={{display: "flex", justifyContent: "center" }}>
                            <HorizRule color="#CC6600" pctWidth="60%" thickness="2px"  />
                        </div>
                        <div> 
                            <div className="pic-event-message-container">
                               {listItemsHaveBeenCreated 
                                   ? ( <div className="pic-event-prompt">To Pitch In, click blue arrow below. </div> )
                                   : ( <div className="pic-event-prompt">No lists have been added to this event. Use your List tab to create your Pitch-In Item List. </div>) }
                            </div>
                        </div> 
                        <div className="pic-event-modifier-mt2">
                            {/*listItemsHaveBeenCreated 
                                ? ( <div className="pic-event-instruction">Click on blue arrow to expand list </div> )
                            : ( <div className="pic-event-instruction">&nbsp; </div> ) */ } 
                               <div>
                                    { this.state.contributions.length > 0 &&
                                        (<PicInvitationContribPanel 
                                                open={panel1IconOpen} handleOnClickForPanel={this.handleOnClickForPanel1} raiseErrorHandler={this.handleRaiseError} 
                                                dataset1={this.state.eventObj}
                                                dataset2={this.state.contributions}
                                                handleContribCountMeInButton={this.handleContribCountMeInButton}
                                                handleRemoveContributor={this.handleRemoveContributor}
                                                handleChangeDataSet2={() => {}}
                                                handleChangeQuantity={() => {}}
                                                getParentStateValue={this.getParentStateValue}
                                                mockMode={true}
                                        />)
                                    }
                                    <div className="pic-event-modifier-mt2" />
                                    { this.state.helpingHandsList.length > 0 &&
                                       ( 
                                        <PicInvitationHelpPanel
                                                open={panel2IconOpen} handleOnClickForPanel={this.handleOnClickForPanel2} raiseErrorHandler={this.handleRaiseError} 
                                                dataset1={this.state.eventObj}
                                                dataset2={this.state.helpingHandsList}
                                                handleHelpingHandsCountMeInButton={this.handleHelpingHandsCountMeInButton}
                                                handleRemoveContributor={this.handleRemoveHelpingHandsContributor}
                                                handleChangeDataSet2={() => {}}
                                                getParentStateValue={this.getParentStateValue}
                                                mockMode={true}
                                        /> )
                                    }
                                <div/> 
                            </div> 
                        </div> 
                        {showResponseButton && (
                        <div>
                            <div className="pic-event-modifier-mt4vary" />
                            <div className="pic-event-pitchin-button-container">
                                <SimpleButton  buttonText="Submit Response" words={3} 
                                            onClickHandler={this.handleSubmitResponse} />
                            </div>
                            <div className="pic-event-modifier-mt2vary" />
                        </div>)
                        }
                        {showThankYouMessage && (
                            <div className="pic-event-message-container">
                                <div className="pic-event-modifier-mt5xx">&nbsp;</div>
                                <div className="pic-event-thankyou-message">Thanks for getting back to us</div>
                                <div className="pic-event-thankyou-message-sub">(To come back to invitation, please refer to invitation email originally sent to you)</div>
                            </div>)
                        }
                        <SimpleModal showModal={this.state.showModal} closeHandler={this.handleCloseModal} 
                                cancelHandler={this.handleCancelModal} 
                                modalText="Would you like to Pitch In? &nbsp; &nbsp;If so, Click Cancel. Otherwise, Submit Response"
                                affirmText="Submit"
                        />
                    </div>
                    <VisibilityWrapper show={showSkyScraper} contentType="advertisement" >
                    <div className="right-ad-container">
                        <h3 className="ad-web-skyscraper">-- Add Section Skyscraper</h3>
                    </div>
                    </VisibilityWrapper>
                  </div>
               </div>
               <VisibilityWrapper show={showAd} contentType="advertisement" >
               <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                   {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                   {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                   {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
               </div> 
               </VisibilityWrapper>
               <Footer />       
                
            </div>
        );
    };
};

const mapDispatchToProps = (dispatch) => ({
    startLogout:  ()       => dispatch(startLogout()),
    picAppError:  (errmsg) => dispatch(picAppError(errmsg))
    
})

const mapStateToProps = (state) => {
    return {
        event: state.event,
        auth: state.auth
        // picapp: state.picapp
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PicInvitationMock);
// export default connect(mapStateToProps, mapDispatchToProps)(PicInvitation);



// WEBPACK FOOTER //
// ./src/components/PicInvitationMock.js